import React from "react";
import { IDSBadge, IDSButton, IDSCard } from "@inera/ids-react";
import { formatDateTimeNoSeconds } from "../../utils/dateTime";
import { getTestExecutionStatusBadge } from "../../utils/testExecutionStatus";

/**
 * Summary card for a single test execution in the /testrapporter list.
 * Opens the full review page at /testrapporter/granska/:id on click.
 */
const ReportAccordionItem = ({ report, navigate, isReviewer }) => {
  const badge = getTestExecutionStatusBadge(report.status);

  // The list is fed metadata-only summaries that carry counted results; the fallback keeps
  // the card working where a full execution object is passed in instead.
  const totalTests  = report.totalTests ?? (report.testResults || []).length;
  const failedTests = report.failedTests ?? (report.testResults || []).filter(t => t.status === "FAILED").length;

  return (
    <IDSCard className="ids-mb-4">
      <div style={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between", gap: "1rem", flexWrap: "wrap" }}>
        <div style={{ flex: "1 1 auto", minWidth: 0 }}>
          <div className="ids-flex" style={{ alignItems: "center", gap: "0.6rem", flexWrap: "wrap", marginBottom: "0.5rem" }}>
            <h2 className="ids-heading-s" style={{ margin: 0 }}>
              {report.organisationName} – {report.selectedContract}
            </h2>
            <IDSBadge type={badge.type}>
              {badge.label}
              {isReviewer && report.reviewedByUserEmail && ` · ${report.reviewedByUserEmail}`}
            </IDSBadge>
          </div>

          <dl
            style={{
              display: "grid",
              gridTemplateColumns: "max-content 1fr",
              rowGap: "0.25rem",
              columnGap: "1rem",
              margin: 0,
              fontSize: "0.875rem",
              color: "var(--ids-palette-neutral-30)",
            }}
          >
            <dt style={{ fontWeight: 600 }}>Inskickad</dt>
            <dd style={{ margin: 0 }}>{formatDateTimeNoSeconds(report.date, "—")}</dd>

            {(report.submittedByUserName || report.submittedByUserEmail) && (
              <>
                <dt style={{ fontWeight: 600 }}>Inskickad av</dt>
                <dd style={{ margin: 0 }}>
                  {report.submittedByUserName || report.submittedByUserEmail}
                </dd>
              </>
            )}

            {totalTests > 0 && (
              <>
                <dt style={{ fontWeight: 600 }}>Tester</dt>
                <dd style={{ margin: 0 }}>
                  {totalTests} totalt
                  {failedTests > 0 && (
                    <span style={{ marginLeft: "0.5rem", color: "var(--ids-palette-error-40)" }}>
                      · {failedTests} misslyckade
                    </span>
                  )}
                </dd>
              </>
            )}
          </dl>
        </div>

        <IDSButton
          size="s"
          // Navigates by id only: the list holds a metadata summary, and the review page
          // loads the full report (answers, comments, results) for the one report opened.
          onClick={() => navigate(`/testrapporter/granska/${report.id}`)}
          style={{ flexShrink: 0, alignSelf: "center" }}
        >
          Öppna
        </IDSButton>
      </div>
    </IDSCard>
  );
};

export default ReportAccordionItem;
